import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from '@mui/material';

const ThemeCustomizationDialog = ({
  open,
  onClose,
  presets,
  onApplyTheme,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2.2,
        border: '1px solid rgba(15, 23, 42, 0.1)',
        boxShadow: '0 24px 52px rgba(15, 23, 42, 0.18)',
      },
    }}
  >
    <DialogTitle
      sx={{
        py: 1.2,
        borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
        background: 'linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 100%)',
        fontWeight: 760,
      }}
    >
      Theme Customization
    </DialogTitle>
    <DialogContent sx={{ pt: 1.25, background: '#F8FAFC' }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.4 }}>
        Choose a cleaner preset for this page. You can still fine-tune sections after applying it.
      </Typography>
      <Grid container spacing={1.4}>
        {presets.map((preset) => (
          <Grid item xs={12} sm={6} key={preset.id}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 2,
                border: '1px solid rgba(15,23,42,0.1)',
                background: '#FFFFFF',
                height: '100%',
              }}
            >
              <CardContent sx={{ p: 1.7 }}>
                <Stack direction="row" spacing={0.8} sx={{ mb: 1.2 }}>
                  <Box sx={{ width: 24, height: 24, bgcolor: preset.primary, borderRadius: 0.8 }} />
                  <Box sx={{ width: 24, height: 24, bgcolor: preset.accent, borderRadius: 0.8 }} />
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      bgcolor: preset.surface,
                      borderRadius: 0.8,
                      border: '1px solid rgba(15,23,42,0.08)',
                    }}
                  />
                </Stack>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                  {preset.label}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ minHeight: 40, mt: 0.7, mb: 1.2 }}>
                  {preset.description}
                </Typography>
                <Button size="small" variant="contained" onClick={() => onApplyTheme(preset)}>
                  Apply Theme
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </DialogContent>
    <DialogActions
      sx={{
        px: 2,
        py: 1.1,
        borderTop: '1px solid rgba(15, 23, 42, 0.08)',
        background: '#FFFFFF',
      }}
    >
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default ThemeCustomizationDialog;
